import moment from "moment/moment";

export const tryFormatDate = (
  date: moment.Moment | string | Date | number | undefined,
  format: string
): string | undefined => {
  try {
    const m = moment.isMoment(date) ? date : moment(date);
    return m.isValid() ? m.format(format) : undefined;
  } catch {
    return undefined;
  }
};
